<div class="padding-16 d-flex flex-column h-100">
	@if (isAddingNewLink) {
		<div class="margin-top-10 width-full flex-grow-1 overflow-auto">
			<embedded-content-add-form [name]="'newLink'" [(ngModel)]="newLink" [webcastId]="webcastId" [isDuplicateName]="isDuplicateNameForForm" [isSidebar]="true" (saveEntry)="onSaveEntry($event)" (cancel)="onCancelAddEntry()">
			</embedded-content-add-form>
		</div>
	} @else {
		@if (contentLinks?.length) {
			<div class="margin-top-10 width-full flex-grow-1 overflow-auto">
				@for (link of contentLinks; track $index; let index = $index) {
					<embedded-content-entry [name]="'link' + index" [(ngModel)]="contentLinks[index]" [showToggleBtn]="true" [showPreviewBtn]="false" [showEditDeleteBtns]="true" (editEntry)="onEditEntry(index)" (updateEntry)="onUpdateEntry(index)" (deleteEntry)="onDeleteEntry(index)">
					</embedded-content-entry>
				}
			</div>
		}
	}

	<div class="margin-top-10 d-flex justify-content-end align-items-center gap-1" [hidden]="isAddingNewLink" [ngClass]="{ 'mt-auto': !!contentLinks?.length }">
		<button type="button" vbBtnPrimary [disabled]="isAddNewDisabled()" (click)="onAddNewClick()">
			{{ 'Event_Embed_Content_AddNew' | translate }}
		</button>
		<vb-ui-tooltip *ngIf="contentLinks?.length >= MAX_EMBEDDED_LINKS" [iconName]="'circle_question_mark'" [placement]="'right'" [text]="'MaximumAmountReached' | translate">
		</vb-ui-tooltip>
	</div>
</div>
